//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import EvaluateScoreAnalysis from "./EvaluateScoreAnalysis.vue";
import wart from "./../../base/wart.vue";
export default {
  name: 'EvaluateScoreList',
  mixins: [GetSiteIdMixin],
  components: {
    EvaluateScoreAnalysis: EvaluateScoreAnalysis,
    wart: wart
  },
  data: function data() {
    return {
      pageTitle: '评价与得分',
      isList: true,
      st: '',
      scope: '',
      scopeId: '',
      status: true
    };
  },
  watch: {
    currentSiteType: function currentSiteType(value) {
      var _this = this;

      this.status = false;
      this.st = value;
      this.$nextTick(function () {
        _this.status = true;

        if (_this.st == null || _this.st == '') {
          _this.$message.warning('请选择监测类型');

          _this.isList = false;
        } else if (_this.st == 32) {
          _this.isList = true;
        } else {
          _this.isList = false;
        }
      });
    },
    currentSiteId: function currentSiteId(value) {
      var _this2 = this;

      this.status = false;
      var ids = this.getTreeCurrentId();
      this.scope = ids[0];
      this.scopeId = ids[1];
      this.$nextTick(function () {
        _this2.status = true;

        if (ids[0] == 1) {
          if (_this2.st == null || _this2.st == '') {
            _this2.$message.warning('请选择监测类型');

            _this2.isList = false;
          }

          _this2.isList = false;
        } else {
          if (_this2.st == null || _this2.st == '') {
            _this2.$message.warning('请选择监测类型');

            _this2.isList = false;
          } else if (_this2.st == 32) {
            _this2.isList = true;
          } else {
            _this2.isList = false;
          }
        }
      });
    }
  },
  created: function created() {},
  computed: {},
  methods: {}
};